import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { ArrowBack } from '@bibliocommons/base-icons';

import './BackLink.scss';

const BackLink = ({ className, label, url }) => {
  return (
    <Link className={cn('cp-admin-browse-back-link', className)} dataKey="back-link" to={url}>
      <ArrowBack />
      <span>{label}</span>
    </Link>
  );
};

BackLink.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default BackLink;
